<template>
  <div class="editor">
    <form-fields :item="item" :lessonId="lessonId" />
  </div>
</template>
<script>
import FormFields from '@/components/formFields/FormFields';

export default {
  name: 'editor',
  props: ['item', 'lessonId'],
  components: {
    FormFields,
  },
};
</script>
